import { REDUCE_PAYMENT_TRANSFER_RESULT_HIDDEN } from '../../constants/actions/payment';

export function reducePaymentTransferResultHidden(payload) {
    return {
        type: REDUCE_PAYMENT_TRANSFER_RESULT_HIDDEN,
        payload,
    };
}
